import { useMount, useSafeState, useUpdateEffect } from "ahooks";
import dayjs from "dayjs";
import waitTime from "@/fun/waitTime";
export default () => {
  const [data, setData] = useSafeState();
  const [loading, setLoading] = useSafeState(false);
  const run = async (token) => {
    // await waitTime(1500);
    // window.eventEmitterGlobal?.emit("EeGlobalLoadingAccountInfo", true);
    setLoading(true);
    // await waitTime(1500);
    setData(undefined);
    const reqFormData = {};
    let res = undefined;
    try {
      res = await fetch(
        `${window.Service_Api_Host}/account/json/login-by-token`,
        {
          headers: {
            "content-type": "application/json",
            token: token,
          },
          method: "POST",
          body: JSON.stringify(reqFormData),
        }
      );
    } catch (e) {
      console.log(`网络异常`, e + "");
    }
    let rsObj = undefined;
    try {
      if (res) {
        rsObj = await res.json();
      }
    } catch (e) {
      rsObj = null;
      console.log(`数据格式异常`, e + "");
    }
    setLoading(false);
    // window.eventEmitterGlobal?.emit("EeGlobalLoadingAccountInfo", false);
    setData(rsObj);
  };

  useMount(() => {
    const token = window.localStorage.getItem("token");
    if (token) {
      run(token);
    }
  });

  return [data, loading, run];
};
